/*eslint-disable*/
import { useEffect, useRef, useState } from 'react';
import { Check, Minus } from 'lucide-react';

const COMMIT_DEBOUNCE_MS = 500;

const NumberCell = ({ value, unit, onChange, disabled }) => {
	const [local, setLocal] = useState(value ?? '');
	const localRef = useRef(local);
	const valueRef = useRef(value);
	const onChangeRef = useRef(onChange);
	const timerRef = useRef(null);
	valueRef.current = value;
	onChangeRef.current = onChange;

	useEffect(() => {
		setLocal(value ?? '');
		localRef.current = value ?? '';
	}, [value]);

	const commit = () => {
		clearTimeout(timerRef.current);
		if (String(localRef.current ?? '') === String(valueRef.current ?? '')) return;
		onChangeRef.current?.(localRef.current);
	};

	const handleTyping = (val) => {
		setLocal(val);
		localRef.current = val;
		clearTimeout(timerRef.current);
		timerRef.current = setTimeout(commit, COMMIT_DEBOUNCE_MS);
	};

	useEffect(() => () => commit(), []);

	return (
		<div className='flex items-center justify-start gap-1 py-2'>
			<input
				type='number'
				value={local}
				disabled={disabled}
				onChange={(e) => handleTyping(e.target.value)}
				onBlur={commit}
				onKeyDown={(e) => {
					if (['-', '+', "'", 'e', 'E'].includes(e.key)) e.preventDefault();
					if (e.key === 'Enter') e.target.blur();
				}}
				className='w-[64px] rounded border border-gray-300 px-1.5 py-1 text-center text-[13px] outline-none transition-colors focus:border-blue-500 disabled:cursor-not-allowed disabled:bg-gray-100'
			/>
			<span className='text-[11px] text-gray-500'>{unit}</span>
		</div>
	);
};

export const cellRenderers = {
	text: ({ value, unit }) => (
		<span className='px-1 text-[13px] text-gray-800'>
			{value === null || value === undefined || value === ''
				? '-'
				: `${value}${unit ? ` ${unit}` : ''}`}
		</span>
	),

	number: (props) => <NumberCell {...props} />,
	checkbox: ({ value, onChange, disabled }) => (
		<div className='flex items-center justify-center py-2'>
			<input
				type='checkbox'
				checked={!!value}
				disabled={disabled}
				onChange={(e) => onChange?.(e.target.checked)}
				className='size-4 cursor-pointer accent-amber-500 disabled:cursor-not-allowed'
			/>
		</div>
	),
	tick: ({ value }) => (
		<div className='flex items-center justify-center py-2'>
			{value ? (
				<Check className='size-4 text-green-600' strokeWidth={3} />
			) : (
				<Minus className='size-4 text-gray-300' />
			)}
		</div>
	),
};
export const renderCellByType = (type, props) => {
	const renderer = cellRenderers[type] || cellRenderers.text;
	return renderer(props);
};
